import React, { useState } from "react";
import "./LearningJourney.css";
import { NavLink } from "react-router-dom";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabsUnstyled from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import "./PythonLearningJourney.css";

const PythonLearningJourney = () => {
  const [value, setValue] = useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };
  return (
    <>
      <div className="learning-Journey-container">
        <h2>Python Learning Journey</h2>
        <div className="lj-menu-wrapper">
          <Box sx={{ width: "100%", typography: "body1" }}>
            <TabContext value={value}>
              <Box>
                <TabList
                  role="tablist"
                  onChange={handleChange}
                  className="main-list"
                  variant="scrollable"
                  scrollButtons="auto"
                  aria-label="lab API tabs example"
                >
                  <Tab
                    role="tab"
                    label="Overall"
                    value="1"
                    className="list1 item"
                  />
                  <Tab
                    role="tab"
                    label="Aware"
                    value="2"
                    className="list2 item"
                  />
                  <Tab
                    role="tab"
                    label="Equipped"
                    value="3"
                    className="list3 item"
                  />
                  <Tab
                    role="tab"
                    label="Competent"
                    value="4"
                    className="list4 item"
                  />
                  {/* <Tab role="tab" label="Expert" value="5" className='list5 item'/> */}
                </TabList>
              </Box>
              <div className="lj-box">
                <TabPanel role="tabpanel" value="1" className="comingsoon">
                  <a
                    href="https://connectedlearning.accenture.com/topics/python"
                    target="_blank"
                  >
                    <img
                      src="images/Python/Overall-Python.png"
                      alt="overall-img"
                      className="lj-images"
                    />
                  </a>
                </TabPanel>
                <TabPanel role="tabpanel" value="2" className="comingsoon">
                  {/* <img src='images/Python/PYTHON AWARE.png' alt='aware-img' className='lj-images' /> */}
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/Python/LearningJourney/Aware/PYTHON-AWARE-BG.png' alt='aware-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='pythoneAware'>
                    <p className='link1'>
                      <a href="https://share.percipio.com/cd/MUlFnOOLr" target="_blank"><img src='images/Python/LearningJourney/Aware/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/b4b2d402-350a-4b98-8e38-cd759a5444a5/videos/970f9c94-73b5-4d5f-8b5e-42362a2d6092" target="_blank"><img src='images/Python/LearningJourney/Aware/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/17231484-de8a-440f-88e8-dd7a0d4e5e14/videos/1b812f3f-a244-48ae-989d-ed5b47e3bebd" target="_blank"><img src='images/Python/LearningJourney/Aware/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/55dbdff9-0b45-4812-8051-6af162872979/videos/77de7eba-0fe0-4ef3-a67f-9afe54329e24" target="_blank"><img src='images/Python/LearningJourney/Aware/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/59f1a55e-f144-4f30-8d41-c9dd5718a6f4/videos/104efe08-bdd4-4a27-8e7b-56ef6eaebf3c" target="_blank"><img src='images/Python/LearningJourney/Aware/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/linked-contents/c4889422-998c-4516-a5cc-1ae57950e457/landing" target="_blank"><img src='images/Python/LearningJourney/Aware/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/dd0a4148-52d7-4123-9b91-9f5442cfccb4/videos/17d4e693-08b0-4293-95e9-c5a7bee609dc" target="_blank"><img src='images/Python/LearningJourney/Aware/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/courses/f171beaf-adfc-4c8b-aca1-5526f0eac1dc/videos/6f86e490-3e8e-43f1-a5ca-8c7f965f8f6d" target="_blank"><img src='images/Python/LearningJourney/Aware/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/4bcc7fbd-da51-4591-a91c-3454501d5dd8/videos/b7851863-98a0-453a-b0c9-d6b7b69433bb" target="_blank"><img src='images/Python/LearningJourney/Aware/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/287827f3-23a5-498b-834a-c512faa88e72/videos/6dbd5aa1-0cf5-41bd-a6a0-fde36b0d12ab" target="_blank"><img src='images/Python/LearningJourney/Aware/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/6b5842f8-e31b-4438-926b-adf0269affea/videos/52561948-6478-436f-ba23-e0e03f2b4e10" target="_blank"><img src='images/Python/LearningJourney/Aware/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://share.percipio.com/cd/2TyEs3FT3" target="_blank"><img src='images/Python/LearningJourney/Aware/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://share.percipio.com/cd/k8L2Jqh97" target="_blank"><img src='images/Python/LearningJourney/Aware/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://accenture.percipio.com/courses/f28aba6d-fe35-4d9f-bb8a-95fd7d65eb41/videos/f64f9af7-954c-43a0-9894-32cca2787775" target="_blank"><img src='images/Python/LearningJourney/Aware/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://accenture.percipio.com/courses/adbd5258-ef8f-4229-99cf-ada429fc04f1/videos/ee251bb3-cfb2-4fce-91a6-c21fdaf5c142" target="_blank"><img src='images/Python/LearningJourney/Aware/15.png'/></a>
                    </p>
                    <p className='link16'>
                      <a href="https://accenture.percipio.com/courses/7fa25cf3-6932-4a0d-b81f-1f9aa5319939/videos/e1eada67-4e98-49e1-b2f2-2a6439a94025" target="_blank"><img src='images/Python/LearningJourney/Aware/16.png'/></a>
                    </p>
                    <p className='link17'>
                      <a href="https://accenture.percipio.com/courses/ff3cae17-ee98-49c0-b7b3-b61e61865d46/videos/9d9e6822-736c-4d57-aa3e-5d4b0e674452" target="_blank"><img src='images/Python/LearningJourney/Aware/17.png'/></a>
                    </p>
                    <p className='link18'>
                      <a href="https://accenture.percipio.com/linked-contents/071ba218-5f2a-4c4d-935a-fa20617283d8/landing" target="_blank"><img src='images/Python/LearningJourney/Aware/18.png'/></a>
                    </p>
                    <p className='link19'>
                      <a href="https://accenture.percipio.com/courses/5245f825-1976-48e8-95cd-88e682da16b4/videos/a6d93347-8099-4eba-80d4-4c65967d081f" target="_blank"><img src='images/Python/LearningJourney/Aware/19.png'/></a>
                    </p>
                    <p className='link20'>
                      <a href="https://share.percipio.com/cd/mjdKTdUzF" target="_blank"><img src='images/Python/LearningJourney/Aware/20.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://connectedlearning.accenture.com/learningboard/1183490-python-aware"
                      target="_blank"
                    >
                      <img
                        src="images/Python/LearningJourney/python-AWARE.png"
                        alt="python-AWARE-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel role="tabpanel" value="3" className="comingsoon">
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/Python/LearningJourney/Equipped/Python-Equipped-BG.png' alt='equipped-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='pythoneEquipped'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/a37e8f04-8097-4faf-8d04-7719d2f14ea7/videos/5a5519e7-0123-4e59-b6f8-b44b0b2b6603" target="_blank"><img src='images/Python/LearningJourney/Equipped/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/9d1f4ac0-ed80-4743-9190-35fd21500e6b/videos/e4d5ecfe-7026-48b5-98ae-d8ccab2259e8" target="_blank"><img src='images/Python/LearningJourney/Equipped/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/ab06526d-3d65-4f86-8216-d92dafd71860/videos/79111d37-0b78-414f-bcb2-a0ab3fc40e7d" target="_blank"><img src='images/Python/LearningJourney/Equipped/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/6dd5db39-2a8a-4e42-a3fb-0246f013cf61/videos/eec02a15-0e83-43e5-b17f-cc7dc0d32d9b" target="_blank"><img src='images/Python/LearningJourney/Equipped/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/bc9c034a-69ee-4c78-9c0e-26c15410e5d5/videos/08f8b794-6a6c-4809-8fd9-889a7cb96a1d" target="_blank"><img src='images/Python/LearningJourney/Equipped/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/linked-contents/936be44d-162f-45d4-8b51-7f97757521b6/landing" target="_blank"><img src='images/Python/LearningJourney/Equipped/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://accenture.percipio.com/courses/2fe44c9b-26b9-48ca-8e5c-cac058c621f3/videos/dd8f1309-34dd-415b-b2c1-f63bfc64e7e9" target="_blank"><img src='images/Python/LearningJourney/Equipped/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://accenture.percipio.com/courses/786bef17-d1b2-48f1-a6b1-3501309a178f/videos/75090928-9a27-4c83-8382-059280bfeddf" target="_blank"><img src='images/Python/LearningJourney/Equipped/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/d8a1141d-311f-491e-9005-875bd8101183/videos/237c3665-da5d-4551-ae8b-e6c92a959cdd" target="_blank"><img src='images/Python/LearningJourney/Equipped/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/142a6430-d900-11e8-8a17-cfd888227de4/videos/586440c0-d901-11e8-8a17-cfd888227de4" target="_blank"><img src='images/Python/LearningJourney/Equipped/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/fadae960-d903-11e8-8a17-cfd888227de4/videos/2ab59540-d904-11e8-8a17-cfd888227de4" target="_blank"><img src='images/Python/LearningJourney/Equipped/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/courses/8f91ed90-de9c-11e8-a894-e93f2bf885c6/videos/084547f0-de9d-11e8-a894-e93f2bf885c6" target="_blank"><img src='images/Python/LearningJourney/Equipped/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/courses/25178ea0-de9e-11e8-a894-e93f2bf885c6/videos/578b34e0-de9e-11e8-a894-e93f2bf885c6" target="_blank"><img src='images/Python/LearningJourney/Equipped/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://accenture.percipio.com/courses/d42ae6f0-3509-11e9-98cb-13537a736c17/videos/8ae417e0-350a-11e9-98cb-13537a736c17" target="_blank"><img src='images/Python/LearningJourney/Equipped/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://accenture.percipio.com/courses/71380ce0-3508-11e9-98cb-13537a736c17/videos/84dc6e80-3508-11e9-98cb-13537a736c17" target="_blank"><img src='images/Python/LearningJourney/Equipped/15.png'/></a>
                    </p>
                    <p className='link16'>
                      <a href="https://www.practice-labs.com/authenticated/vNext/vn-content.aspx" target="_blank"><img src='images/Python/LearningJourney/Equipped/16.png'/></a>
                    </p>
                    <p className='link17'>
                      <a href="https://accenture.percipio.com/courses/41a8c170-e280-11e8-8b80-bf03d5c2cd93/videos/97bf5f00-e281-11e8-8b80-bf03d5c2cd93" target="_blank"><img src='images/Python/LearningJourney/Equipped/17.png'/></a>
                    </p>
                    <p className='link18'>
                      <a href="https://accenture.percipio.com/courses/08f57510-e282-11e8-8b80-bf03d5c2cd93/videos/6b9c83a0-e284-11e8-8b80-bf03d5c2cd93" target="_blank"><img src='images/Python/LearningJourney/Equipped/18.png'/></a>
                    </p>
                    <p className='link19'>
                      <a href="https://www.practice-labs.com/authenticated/vNext/vn-content.aspx" target="_blank"><img src='images/Python/LearningJourney/Equipped/19.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://connectedlearning.accenture.com/learningboard/1183541-python-equipped"
                      target="_blank"
                    >
                      <img
                        src="images/Python/LearningJourney/python-Equipped.png"
                        alt="python-Equipped-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                <TabPanel role="tabpanel" value="4" className="comingsoon">
                  <div className="LJ-link-Wrapp">
                    {/* <img src='images/Python/LearningJourney/Competent/Python-Competent-BG.png' alt='equipped-img' className='lj-images' />
                  <div className='linkInner-Container'>
                    <div className='linkContent' id='pythoneCompetent'>
                    <p className='link1'>
                      <a href="https://accenture.percipio.com/courses/2dc031b2-1e77-46ea-99f0-a0dec128b2a0/videos/5765365b-66c2-4127-9f1d-ceb0d033b987" target="_blank"><img src='images/Python/LearningJourney/Competent/1.png'/></a>
                    </p>
                    <p className='link2'>
                      <a href="https://accenture.percipio.com/courses/eb9a9896-ddea-47dc-a776-54a4f060cc9a/videos/bde4304c-fcf6-4c56-85db-4923ebf7a8d4" target="_blank"><img src='images/Python/LearningJourney/Competent/2.png'/></a>
                    </p>
                    <p className='link3'>
                      <a href="https://accenture.percipio.com/courses/b68ab249-86b5-46ed-a1e4-ea73b04a7557/videos/d1070596-6b6a-4b23-8cb3-29899e220c1d" target="_blank"><img src='images/Python/LearningJourney/Competent/3.png'/></a>
                    </p>
                    <p className='link4'>
                      <a href="https://accenture.percipio.com/courses/8b33fc38-0782-43a9-b92f-85cce6448215/videos/67c613ab-6f0c-49e2-bb87-71efd3a5aa2b" target="_blank"><img src='images/Python/LearningJourney/Competent/4.png'/></a>
                    </p>
                    <p className='link5'>
                      <a href="https://accenture.percipio.com/courses/9fa95c02-6d81-4f8d-bc4a-dc49780e846b/videos/fc193847-5b16-454a-99e9-86f5d08d7519" target="_blank"><img src='images/Python/LearningJourney/Competent/5.png'/></a>
                    </p>
                    <p className='link6'>
                      <a href="https://accenture.percipio.com/courses/ff307df7-22fc-4ef5-9d4b-f0349e09bff3/videos/a43d742a-20fb-4e7a-92df-dfdc1fbb8f5e" target="_blank"><img src='images/Python/LearningJourney/Competent/6.png'/></a>
                    </p>
                    <p className='link7'>
                      <a href="https://share.percipio.com/cd/w4Lr8ALrC" target="_blank"><img src='images/Python/LearningJourney/Competent/7.png'/></a>
                    </p>
                    <p className='link8'>
                      <a href="https://share.percipio.com/cd/OUT8uNNDC" target="_blank"><img src='images/Python/LearningJourney/Competent/8.png'/></a>
                    </p>
                    <p className='link9'>
                      <a href="https://accenture.percipio.com/courses/445f36eb-1089-4089-81ef-9ca04d201b10/videos/c3702630-a48f-41af-8fa3-dc1fb92ffc98" target="_blank"><img src='images/Python/LearningJourney/Competent/9.png'/></a>
                    </p>
                    <p className='link10'>
                      <a href="https://accenture.percipio.com/courses/33d8b10b-1308-45ce-b896-ea25b6ff4560/videos/74805f58-e988-409d-ae6b-942679de830b" target="_blank"><img src='images/Python/LearningJourney/Competent/10.png'/></a>
                    </p>
                    <p className='link11'>
                      <a href="https://accenture.percipio.com/courses/0a549ade-bd41-47ef-b634-674eeaae648f/videos/946204ac-a403-4427-8ea5-b535cf2c349f" target="_blank"><img src='images/Python/LearningJourney/Competent/11.png'/></a>
                    </p>
                    <p className='link12'>
                      <a href="https://accenture.percipio.com/courses/1a38d4fb-0d8b-4fbf-ba5d-4ed381c06460/videos/a6dcd2c6-c05f-49bb-a2a7-4eae5657e833" target="_blank"><img src='images/Python/LearningJourney/Competent/12.png'/></a>
                    </p>
                    <p className='link13'>
                      <a href="https://accenture.percipio.com/courses/7cc96747-d390-4385-b967-6ba65298c70a/videos/76bdd6eb-59db-4967-9087-fe9609f8eb81" target="_blank"><img src='images/Python/LearningJourney/Competent/13.png'/></a>
                    </p>
                    <p className='link14'>
                      <a href="https://accenture.percipio.com/courses/a7a1ce56-6710-432d-95be-e563182f8ec5/videos/46918167-8681-4507-9889-8883a7e6e9ee" target="_blank"><img src='images/Python/LearningJourney/Competent/14.png'/></a>
                    </p>
                    <p className='link15'>
                      <a href="https://accenture.percipio.com/courses/755b9ea8-0697-4b5d-896e-16683c20aba4/videos/1bd50f0e-9a23-4cc8-a3d4-630d313fa5e1" target="_blank"><img src='images/Python/LearningJourney/Competent/15.png'/></a>
                    </p>
                    <p className='link16'>
                      <a href="https://accenture.percipio.com/courses/fe5fa627-e3e7-41e9-a360-72af8401543b/videos/e1490e9b-fd94-423d-8793-eb860951eded" target="_blank"><img src='images/Python/LearningJourney/Competent/16.png'/></a>
                    </p>
                    <p className='link17'>
                      <a href="https://accenture.percipio.com/courses/729d67b7-a2d7-4c23-b1ee-b086ccba6c8e/videos/c0292909-ad2f-4a4c-b1d3-88e03e00ef53" target="_blank"><img src='images/Python/LearningJourney/Competent/17.png'/></a>
                    </p>
                  </div>
                  </div> */}
                    <a
                      href="https://connectedlearning.accenture.com/learningboard/1183568-python-competent"
                      target="_blank"
                    >
                      <img
                        src="images/Python/LearningJourney/python-Competent.png"
                        alt="python-Competent-img"
                        className="lj-images"
                      />
                    </a>
                  </div>
                </TabPanel>
                {/* <TabPanel role="tabpanel" value="5" className='comingsoon'>Coming Soon</TabPanel> */}
              </div>
            </TabContext>
          </Box>
        </div>
      </div>
    </>
  );
};
export default PythonLearningJourney;
